<div
  #container
  class="widget-container"
  [class.widget-container_hidden]="vkInstall?.active"
>
  <router-outlet></router-outlet>
</div>
<app-vk-community-install #vkInstall></app-vk-community-install>
<app-preloader></app-preloader>
<app-modal [bodyElement]="bodyElement"></app-modal>
<app-dialog></app-dialog>
